import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const generateCertificate = async (metaData, onDownloadComplete) => {
  try {
    const isParticipant = metaData?.userType === "participant";

    const certificateTitle = isParticipant
      ? "Certificate of Training Completion<br/>- Group Participation"
      : "Certificate of Completion";

    const traineeName = metaData?.userName ?? "";

    const certificateDate = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const p1 = isParticipant
      ? `has successfully completed  the training topic`
      : `has successfully completed the training topic`;

    const topicNameBold = `<div style='font-weight:bold;text-transform:uppercase;margin-top:4px;text-align:center;font-family:Lato;font-size:11px;'>${metaData?.record?.TopicName}</div>`;
    const p2 = isParticipant
      ? `with the participation of its clinical team,<br/>as part of the VITROMED Academy educational program.`
      : `as part of the VITROMED Academy educational program.`;

    const p3 = isParticipant
      ? "This certificate recognizes the institution's commitment to continuous professional<br/>development and high standards in Assisted Reproductive Technology (ART)."
      : `This certificate acknowledges the participant's dedication to advancing knowledge in the field<br/>of Assisted Reproductive Technology (ART).`;

    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.width = "1123px";
    container.style.height = "797px";
    document.body.appendChild(container);

    container.innerHTML = `
      <table cellpadding="0" cellspacing="0" width="1123" height="797" bgcolor="#fff"
        style="background-image:url(bg.jpg);background-size:100% 100%;background-repeat:no-repeat;border:solid 2px #d9f0f8;">
        <tr><td>
          <table cellpadding="0" cellspacing="0" style="padding:16px;width:100%">
            <tr><td>
              <table style="height:50px;width:100%;padding:16px"><tr><td></td></tr></table>
              <table style="padding:16px;width:100%"><tr><td align="center">
                <img src="logo.svg" alt="logo" style="width:256px"/>
              </td></tr></table>
              <table cellpadding="0" cellspacing="0" height="566" style="padding:16px;width:100%">
                <tr><td>
                  <table style="padding:16px;width:100%"><tr><td align="center">
                    <span style="display:block;width:100%;font-size:37px;text-transform:uppercase;margin-bottom:17px;font-family:'Trajan Pro 3', serif;">
                      ${certificateTitle}
                    </span>
                  </td></tr>
                  <tr><td align="center">
                    <h1 style="font-size:15px;text-transform:uppercase;font-weight:300;font-family:'Trajan Pro 3', serif;">This is to certify that</h1>
                  </td></tr></table>
                  <table style="width:100%"><tr><td align="center">
                    <table style="width:50%;margin:0 auto"><tr><td align="center">
                      <h1 style="font-size:32px;font-weight:400;font-family:'Open Sans';font-style:italic;
                                 padding-bottom:16px;border-bottom:1px solid #000;">
                        ${traineeName}
                      </h1>
                    </td></tr></table>
                  </td></tr></table>
                  <table style="padding:16px;width:100%">
                    <tr><td><p style="width:80%;margin:0 auto 4px;font-size:11px;text-align:center;font-family:'Lato';">${p1}</p></td></tr>
                    <tr><td><p style="width:80%;margin:0 auto 4px;font-size:11px;text-align:center;font-family:'Lato';">${topicNameBold}</p></td></tr>
                    <tr><td><p style="width:80%;margin:0 auto 16px;font-size:11px;text-align:center;font-family:'Lato';">${p2}</p></td></tr>
                    <tr><td><p style="width:80%;margin:0 auto;font-size:11px;text-align:center;font-family:'Lato';">${p3}</p></td></tr>
                  </table>
                  <table style="padding:16px;width:100%"><tr>
                    <td align="center" style="width:33%">
                      <div style="font-family:'Open Sans'; font-size:10px;">${certificateDate}</div>
                      <div style="width:25%;margin:auto;margin-top:8px;padding-top:8px;font-family:'Open Sans'; font-size:10px; white-space:nowrap;">
                        Date of Completion
                      </div>
                    </td>
                    <td align="center" style="width:33%">
                      <img src="signature.png" style="width:144px;height:auto" alt="signature"/>
                      <div style="width:75%;margin:auto;border-top:1px dashed #ccc;margin-top:8px;padding-top:8px;font-family:'Times New Roman', serif;text-align:center">
                        <div style="line-height:1.2">DR. HEIKE JOCKWER</div>
                        <div style="line-height:1.2; font-size:10px;">Director of Operations at VITROMED GmbH</div>
                      </div>
                    </td>
                    <td align="center" style="width:33%">
                      <img src="signature2.png" style="width:144px;height:auto" alt="signature"/>
                      <div style="width:75%;margin:auto;border-top:1px dashed #ccc;margin-top:8px;padding-top:8px;font-family:'Times New Roman', serif;text-align:center">
                        <div style="line-height:1.2">DR. ISABELLA SPYROPOULOU</div>
                        <div style="line-height:1.2; font-size:10px;">Scientific Affairs Manager at VITROMED GmbH</div>
                      </div>
                    </td>
                  </tr></table>
                </td></tr>
              </table>
            </td></tr>
          </table>
        </td></tr>
      </table>
    `;

    await new Promise((r) => setTimeout(r, 500));
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      width: 1123,
      height: 797,
      scrollX: 0,
      scrollY: 0,
      windowWidth: 1123,
      windowHeight: 797,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ orientation: "landscape", unit: "pt", format: [1123, 797] });
    pdf.addImage(imgData, "PNG", 0, 0, 1123, 797);
    pdf.save(metaData?.record?.TopicName + "_certificate.pdf");

    onDownloadComplete?.();
  } catch (err) {
    console.error("PDF generation failed:", err);
    onDownloadComplete?.(err);
  } finally {
    const containerToRemove = document.querySelector("div[style*='left: -9999px']");
    if (containerToRemove) {
      document.body.removeChild(containerToRemove);
    }
  }
};
